<script lang="ts">
  import Icon from '$shared/atoms/Icon/Icon.svelte';
  import WithList from '$shared/molecules/WithList/WithList.svelte';
  import Label from '$provider/constants/Label';
  import Button from '$shared/atoms/Button/Button.svelte';

  interface Props {
    list?: CommonList[];
    loading?: boolean;
    disabled?: boolean;
    onselect?: (option: CommonList) => void;
  }

  let { list = [], loading = false, disabled = false, onselect }: Props = $props();

  let showOption = $state(false);

  const onClickButton = (): void => {
    showOption = !showOption;
  };

  const onClickOption = (option: CommonList): void => {
    onselect?.(option);
    showOption = false;
  };

  const onOptionClose = (): void => {
    showOption = false;
  };
</script>

<div class="comp-report-option">
  <WithList {list} show={showOption} onclick={onClickOption} onclose={onOptionClose}>
    <div class="option-btn">
      <Button
        {loading}
        disabled={loading || disabled}
        active={showOption}
        onclick={onClickButton}
        name="reports-btn"
      >
        <div class="label">{Label.Reports}</div>
        <div class="icon">
          <Icon value="icon-chevron-down {showOption && 'active'}" />
        </div>
      </Button>
    </div>
  </WithList>
</div>

<style>
  .comp-report-option {
    position: relative;
  }
  .option-btn {
    padding: 0 8px;
  }
  .option-btn,
  .option-btn .icon {
    display: flex;
    align-items: center;
    justify-content: center;
  }
  .option-btn .label {
    margin-right: 8px;
    line-height: 30px;
  }
</style>
